<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <b-row>
            <b-col cols="12">
              <SchedulesHistory></SchedulesHistory>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
export default {
  data() {
    return {
      isLoading: false,
      scheduleListFilters: {
        pageNumber: 1,
        count: 10,
        studentUserId: null,
        masterUserId: null,
        startDate: null,
        endDate: null,
        startCreateDate: null,
        endCreateDate: null,
        priceCategory: null,
        isVip: null,
        studentMobile: null,
        studentFullname: null,
        masterMobile: null,
        masterFullname: null,
      },
    };
  },
  methods: {},
  components: {
    BContainer,
    BCard,
    BRow,
    BCol,
    BForm,
    BFormCheckbox,
    BFormRadio,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BInputGroup,
    FiltersWrapper,
    SchedulesHistory,
  },
};
import FiltersWrapper from "@/views/components/Utils/FiltersWrapper.vue";
import SchedulesHistory from "@/views/components/Schedule/SchedulesHistory.vue";
import { getUserData } from "@/auth/utils";

import {
  BContainer,
  BCard,
  BRow,
  BCol,
  BForm,
  BFormCheckbox,
  BFormRadio,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
  BInputGroup,
} from "bootstrap-vue";
</script>
